import { shouldDisableCostlyVendors } from '../flags/utils'

export const BRAZE_SDK_URL = 'sdk.iad-02.braze.com'

export const BRAZE_SDK_KEY = process.env.BRAZE_SDK_KEY ?? ''
export const shouldInitializeBraze = (enabled: boolean): boolean => {
  if (!enabled) {
    return false
  }
  if (!BRAZE_SDK_KEY) {
    console.error('[Braze] BRAZE_SDK_KEY is not configured. SDK will not be initialized.')
    return false
  }
  if (shouldDisableCostlyVendors) {
    return false
  }
  if (typeof window !== 'undefined' && window.Cypress) {
    return false
  }
  return true
}
